export default __webpack_public_path__ + "static/media/ktp-invalid-example.7eca98ec.png";